<template>
<footer class="site-footer">
      <div class="wrap">
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="footer-logo"><img src="/assets/lingmiao-accelerator-logo.png" alt="羚喵加速器"><b>羚喵加速器</b></div>
            <p>面向 Android 手游玩家的游戏网络加速工具。加速服务登录后使用，具体游戏与区服以支持列表为准。</p>
          </div>
          <div class="footer-col">
            <h4>产品</h4>
            <a href="#library" data-route="library">游戏库</a><a href="#download" data-route="download">下载中心</a><a href="#download" data-route="download">版本记录</a>
          </div>
          <div class="footer-col">
            <h4>服务</h4>
            <a href="#about" data-legal="terms">用户协议</a><a href="#about" data-legal="privacy">隐私政策</a><a href="#help" data-route="help">帮助与反馈</a>
          </div>
          <div class="footer-col">
            <h4>运营主体</h4>
            <p>湖南小算科技信息有限公司</p>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备19014074号-26</a>
          </div>
        </div>
        <div class="footer-contact" aria-label="经营联系信息">
          <div class="footer-contact-heading">
            <span class="footer-contact-kicker">BUSINESS CONTACT</span>
            <strong>经营联系信息</strong>
          </div>
          <div class="footer-contact-item">
            <span class="footer-contact-icon" aria-hidden="true">地</span>
            <span class="footer-contact-copy"><small>实际办公地址</small><span>湖南省长沙市岳麓区洋湖街道恒伟星中心T3栋1001</span></span>
          </div>
          <a class="footer-contact-item footer-contact-phone" href="tel:19911594186">
            <span class="footer-contact-icon" aria-hidden="true">电</span>
            <span class="footer-contact-copy"><small>联系电话</small><span>19911594186</span></span>
          </a>
        </div>
      <div class="footer-bottom">© 2026 湖南小算科技信息有限公司。<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">湘ICP备19014074号-26</a></div>
      </div>
    </footer>
</template>
